import React from "react";
import { Link } from "react-router-dom";
import "./Home.css";

function Home() {
    return (
        <div className="home-page">
            <section className="hero">
                <div className="hero-content">
                    <h1 className="hero-title">Vans, Parts, and Repairs</h1>
                    <p className="hero-subtitle">Your local partner for vehicles and expert service.</p>
                    <Link to="/services" className="btn btn-primary">Explore Services</Link>
                </div>
            </section>

            <main className="main-content">
                <section className="home-section about-preview">
                    <h2>A Commitment to Quality and Service</h2>
                    <p>With years of experience, KrisCars4 Ltd is dedicated to providing reliable vehicles and exceptional customer care.</p>
                    <Link to="/about" className="btn btn-primary">Learn More About Us</Link>
                </section>

                <section className="home-section services-preview">
                    <h2>Our Core Services</h2>
                    <div className="service-cards">
                        <div className="card">
                            <h3>🚗 Van Sales</h3>
                            <p>Hand-picked, quality used vans for any needs.</p>
                            <a href="https://www.ebay.co.uk/itm/277481000710" target="_blank" rel="noopener noreferrer" className="btn btn-primary">Vans for sale</a>
                        </div>
                        <div className="card">
                            <h3>🛠️ Expert Repairs</h3>
                            <p>From routine maintenance to major repairs, our mechanic keeps you on the road.</p>
                            <Link to="/contact" className="btn btn-primary">Contact Us</Link>
                        </div>
                        <div className="card">
                            <h3>🚙 Parts on eBay</h3>
                            <p>Find a wide range of tested car and van parts on our official eBay store.</p>
                            <a href="https://www.ebay.co.uk/str/kriscars4ltd" target="_blank" rel="noopener noreferrer" className="btn btn-primary">Visit Store</a>
                        </div>
                    </div>
                </section>

                <section className="home-section contact-preview">
                    <h2>Get in Touch</h2>
                    <p>Ready to talk? We're here to help with your vehicle needs.</p>
                    <p className="contact-info">
                        <strong>Email:</strong> kriscars4ltd@gmail.com | <strong>Phone:</strong> 0776 021 5891
                    </p>
                    <Link to="/contact" className="btn btn-primary">Contact Us Online</Link>
                </section>
            </main>
        </div>
    );
}

export default Home;